import { useState, useEffect } from "react";
import { useUser } from "utils/hooks";

import API from "utils/api";

const SHARED_PROMISES = {};

export default function usePage(slug) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPage() {
      setLoading(true);

      SHARED_PROMISES[slug] ??= API.fetchPage(token, slug);
      const { response, data } = await SHARED_PROMISES[slug];

      if (response.ok) {
        setResult(data);
        setError(null);
      } else {
        setError(data);
        setResult(null);
      }

      setLoading(false);
    }

    fetchPage();
  }, [slug]);

  return {
    loading,
    error,
    page: result,
  };
}
